import { render, staticRenderFns } from "./propertyownership.vue?vue&type=template&id=3bcd6ddc&scoped=true"
import script from "./propertyownership.vue?vue&type=script&lang=js"
export * from "./propertyownership.vue?vue&type=script&lang=js"
import style0 from "./propertyownership.vue?vue&type=style&index=0&id=3bcd6ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcd6ddc",
  null
  
)

export default component.exports